import type { MaybeRef } from 'vue';

import type { SellingMethod, AuctionListingItemEntity, DirectSaleListingItemEntity } from '~/apiClient';
import type {
    AuctionListingItemEntityWithSellingMethod,
    DirectSaleListingItemEntityWithSellingMethod,
    SaleListingItemEntity,
} from '~/types/sale.type';

export interface UseSaleListingWithChannelProps<T> {
    sales: Ref<AuctionListingItemEntity[] | DirectSaleListingItemEntity[]>;
    sellingMethod: MaybeRef<T>;
}

export interface UseSaleListingWithChannelReturn {
    sales: ComputedRef<SaleListingItemEntity[]>;
}

export const useSaleListing = <T extends SellingMethod>({
    sales,
    sellingMethod,
}: UseSaleListingWithChannelProps<T>): UseSaleListingWithChannelReturn => {
    const salesWithSellingMethod = computed(() =>
        sales.value.map(
            sale =>
                ({ ...sale, sellingMethod: unref<SellingMethod>(sellingMethod) }) as T extends SellingMethod.Auction
                    ? AuctionListingItemEntityWithSellingMethod
                    : DirectSaleListingItemEntityWithSellingMethod
        )
    );

    return {
        sales: salesWithSellingMethod,
    };
};
